import React from 'react'
import Layout from '../Components/Layout'
import Try from './Try'
import Navbar from '../Components/NavBar'
import ExperienceTab from '../Components/ExperienceTab'

const Experience = () => {
  return <Layout title='Sarvadnya || Experience' >
    <div className=' relative min-h-screen  '>
      <Try />
      <Navbar />
      <ExperienceTab />

    </div>
  </Layout>
}

export default Experience